import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFeatures } from "src/config/featureManager";
import { ActionTypes, FeatureKeysType, IActionTrackingData, ModuleMap, ModuleTypes } from "src/pages/Studies/models/interfaces";
import { updateUserActivityData } from "../states/userActivitySlice";

export const useActionTracking = (screenName: string) => {
	const dispatch = useDispatch();
	const { isFeatureAvailable } = useFeatures();
	const isUserActivityMonitoring = isFeatureAvailable(FeatureKeysType.UserActivityMonitoring);
	const { isStandardQueryMode } = useSelector((state: any) => state.askKuralSlice);

	const trackAction = useCallback(
		(sub_feature: string, data: IActionTrackingData = {}) => {
			if (!isUserActivityMonitoring) {
				return;
			}
			// Safely destructure with default values
			const {
				study_id = null,
				study_name = null,
				action_name = null,
				file_name = null,
				file_id = null,
				file_type = null,
				ques_id = null,
				type = null,
				feature = null,
				subAction = null,
				module = null,
				rating = undefined,
				count = null,
				featureName = null,
				showReflectiveFeedbackModal = false,
			} = data || {};
			const timestamp = new Date().toISOString();

			if (rating !== undefined) {
				dispatch(
					updateUserActivityData({
						event_type: "ASK_KURAL_RATING",
						module: showReflectiveFeedbackModal
							? ActionTypes.ASK_KURAL_REFLECTIVE_MODE_FEEDBACK
							: isStandardQueryMode
								? ActionTypes.ASK_KURAL_REFLECTIVE
								: module || action_name || screenName,
						rating: count,
					}),
				);
			} else {
				const actionName = action_name === ModuleTypes.Notes ? ModuleMap.Notes : action_name === ModuleTypes.WebBoards ? ModuleMap.WebBoards : action_name;
				const moduleName = module || actionName || screenName;
				dispatch(
					updateUserActivityData({
						event_type: "USER_ACTION",
						module: moduleName,
						feature: feature ? sub_feature : featureName || screenName,
						sub_feature: feature ? subAction || undefined : sub_feature,
						type: feature && type === undefined ? undefined : type,
						description: `User performed action: ${sub_feature} ${study_name ? `of study: ${study_name}` : ""}`,
						metadata: { study_id, study_name, file_name, file_id, file_type, ques_id },
						start_time: timestamp,
						end_time: timestamp,
					}),
				);
			}
		},
		[screenName, isStandardQueryMode],
	);

	return { trackAction };
};
